import {combineReducers} from "redux";
import products from './ products'
import carts from './carts'
import filter from "./filter";

export default combineReducers({
    products,
    carts,
    filter
});